import styled from "styled-components";

export const Container = styled.section`
    width: 100%;    
    display: flex;
    flex-direction: column;

    color: #58626c;
    padding: 0 3rem;
    
    h1 {
        font-family: 'Great Vibes', sans-serif;
        font-size: 4rem;
        font-weight: 200;
        margin: 0 auto;
    }

    h2 {
        max-width: 500px;
        margin: 1rem 0 0;
        font-family: 'Josefin Slab', sans-serif;
        font-weight: 200;
        font-size: 2rem;
        color: #58626c;
    }

    @media (max-width: 770px) {
        padding: 0 1rem;
    }

    @media (max-width: 500px) {
        h1 {
            font-size: 3rem;
        }
        h2 {
            font-size: 1.7rem;
        }
        p {
            font-size: 12px;
        }
    }


`

export const Content = styled.div`
    display: flex;
    margin-top: 30px;
    width: 100%;
    
    div.caterers {  
        display: flex; 
        flex-direction: column;
        background: #e2799b;
        padding: 20px;
        border-top-left-radius: 20px;        
        border-bottom-left-radius: 20px; 
        width: 20%;       
    } 

    ul li {
        display: flex;
        align-items: center;
        margin: 10px 0;
        color: #fff;
        opacity: 0.7;
        font-size: 16px;

        &:hover {
            opacity: 1;
            cursor: pointer;
            font-weight: bold;
        }

        svg {
            display: none;
            margin-right: 3px;
            height: 2rem !important;
            width: 2rem !important;
        }
    }

    li.active {
        opacity: 1;
        font-weight: bold;

       svg {
            display: flex;
        }
    }

    div.row {
        display: flex;
        justify-content: space-around;
        width: 100%;
    }

    div.details {
        width: 80%;
        background-color: #FBCFDD;
        border-top-right-radius: 20px;        
        border-bottom-right-radius: 20px;
        
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;

        div.description {
            width: 50%;

            > ul {
                display: flex;
            }

            li.redes {
                opacity: 1;
                transition: transform 0.3s;

                &:hover {
                    transform: translateY(-10px);
                }
            }
            li.redes img {
                margin-right: 10px;
            }

            p {
                font-size: 16px;
            }

        }

        img.photoOnly {
            width: 100%;
            box-shadow: 0 0 10px;
            border-radius: 20px;
            display: flex;
        }
        img.photoOnlyPartiu {
            width: 100%;
            display: flex;
        }
    }

    div.fotos-fornecedores {
        width: 50%;
        margin-left: 20px;
    }   

    @media (max-width: 750px) {
        display: flex;
        flex-direction: column;

        div.caterers {
            display: flex; 
            flex-direction: column;
            background: #e2799b;
            padding: 10px;
            border-top-left-radius: 20px;        
            border-bottom-left-radius: 0; 
            border-top-right-radius: 20px; 
            width: 100%; 
            
            ul {
                display: flex;
                justify-content: center;
                flex-wrap: wrap;
                
                li {
                    font-size: 14px;
                    margin: 3px 0;
                }                

                li::after {
                    content: "|";
                    color: #FBCFDD;
                    margin: 0 10px;
                }
                li:last-child::after {
                    content: "";
                }
            }
        }

        div.details {
            width: 100%;
            border-top-right-radius: 0;        
            border-bottom-right-radius: 20px;
            border-bottom-left-radius: 20px;
            div.description {
                p {
                    font-size: 14px;
                }
            }
        }
    }
    @media (max-width: 600px) {
        div.row {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
        }
        div.description {
            width: 100% !important;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
        }
        div.fotos-fornecedores {
            width: 100%;
            margin-left: 0;
        }
    }
    
`